import { defineStore } from 'pinia'
import { getPersonalizationData } from '@/api/v2/settings'

interface AccountSettingsState {
  custom_logo: boolean
  /** The account's own logo; empty while the account has none. */
  nav_logo: string
}

/** The sidebar always carries the Centrics mark; the account's own logo sits in the navbar. */
export const CENTRICS_LOGO = 'https://nbg1.your-objectstorage.com/centrics-public-assets/navbar/centrics-app-logo-horizontal_white_190x50.png'
export const CENTRICS_ICON = 'https://nbg1.your-objectstorage.com/centrics-public-assets/navbar/centrics-app-logo-square_white_54x50.png'

/** Bumped by resetState() (logout, account switch). */
let epoch = 0

export const useAccountSettingsStore = defineStore('accountSettings', {
  state: (): AccountSettingsState => ({
    custom_logo: false,
    nav_logo: ''
  }),

  actions: {
    /** Back to no own logo; an answer of the previous session still in flight is dropped. */
    resetState() {
      epoch++
      this.$reset()
    },

    async getAccountSettings() {
      const session = epoch
      const resp = await getPersonalizationData()
      if (session !== epoch) return resp.data

      if (resp.data.logo) {
        this.nav_logo = resp.data.logo
        this.custom_logo = true
      }

      return resp.data
    }
  }
})
